export const OpeningsEnglish = {
  backToHiringPlan: 'Back to hiring plan',
  cannotCreatedOpeningHODError: 'Cannot create requisition, please contact admin to assign HOD to the respective selected department.',
  openingDetails: 'Requisition details',
  approvalFlow: 'Approval flow',
  addOpening: ' Submit Requisition',
  hiringPlanTabs: {
    toBeHired: 'To be Hired',
    hired: 'Hired',
    pendingApprovalFlow: 'Pending approvals',
    myOpenings: 'My requisitions',
    rejected: 'Rejected'
  },
  form: {
    openingId: 'Requisition ID',
    openingFor: 'Requisition for',
    roleName: 'Role name',
    jobName: 'Requisition name',
    newJob: 'New job',
    sameJobAsExistingInATS: 'Same job exists in ATS',
    addDescription: 'Add description',
    chooseExistingJob: 'Choose existing job',
    budgetType: 'Budget type',
    openingType: 'Requisition type',
    employeeBackFillFor: 'Employee (Backfill for)',
    department: 'Department',
    location: 'Location',
    employmentType: 'Employment type',
    targetHiredDate: 'Target hire date',
    targetSalaryPerCandidate: 'Target salary per candidate',
    hiringManager: 'Hiring manager',
    additionalNotes: 'Additional notes',
    budgeted: 'Budgeted',
    unbudgeted: 'Unbudgeted',
    newHire: 'New hire',
    backFillOrReplacement: 'Backfill / Replacement',
    month: 'Month',
    quarter: 'Quarter',
    year: 'Year',
    headcount: 'Headcount',
    placeHolders: {
      enterRoleName: 'Enter role name',
      enterJobName: 'Enter requisition name',
      enterEmployeeName: 'Enter employee name',
      selectEmployee: 'Select employee',
      selectDepartment: 'Select department',
      selectLocation: 'Select location',
      selectEmploymentType: 'Select employment type',
      selectExpectedStartDate: 'Select expected start date',
      selectTargetHireDate: 'Select target hire date',
      enterSalary: 'Enter salary',
      selectHiringManager: 'Select hiring manager',
      addAdditionalInfo: 'Add any additional information'
    },
    formRules: {
      openingId: 'Requisition ID is required',
      jobOpeningFor: 'Please choose requisition for',
      roleName: 'Please enter role name',
      description: 'Please enter description',
      budgetType: 'Please choose budget type',
      openingType: 'Please choose requisition type',
      employee: 'Please select employee',
      employeeName: 'Please enter employee name',
      department: 'Please select department',
      location: 'Please select location',
      employmentType: 'Please select employment type',
      targetHiredDate: 'Please select target date',
      salaryRange: 'Please enter salary range',
      salaryCurrency: 'Please select salary currency',
      salaryFrequency: 'Please select salary frequency',
      hiringManager: 'Please select hiring manager',
      recruiter: 'Please select recruiter',
      job: 'Please select job',
      offer: 'Please select offer',
      headcount: 'Please enter headcount number greater than 0.'
    }
  },
  filters: {
    job: 'Job',
    department: 'Department',
    location: 'Location',
    targetHiredDate: 'Target hire date',
    recruiter: 'Recruiter',
    openingType: 'Requisition type',
    budgetType: 'Budget type'
  },
  successMessages: {
    openingSavedAsDraft: 'Requisition details have been saved successfully',
    openingCreated: 'Requisition successfully created'
  }
}

export const OpeningsArabic = {
  backToHiringPlan: 'الرجوع إلى خطة التوظيف',
  cannotCreatedOpeningHODError: 'لا يمكن إنشاء الوظيفة الشاغرة، يرجى الاتصال بالمسؤول لتعيين رئيس القسم للقسم المحدد.',
  openingDetails: 'تفاصيل الوظيفة الشاغرة',
  approvalFlow: 'مسار الموافقة',
  addOpening: ' تقديم طلب فتح',
  hiringPlanTabs: {
    toBeHired: 'للإستئجار',
    hired: 'تم التوظيف',
    pendingApprovalFlow: 'في انتظار الموافقات',
    myOpenings: 'وظائفي الشاغرة',
    rejected: 'مرفوضة'
  },
  form: {
    openingId: 'رقم الوظيفة الشاغرة',
    openingFor: 'الوظيفة الشاغرة لـ',
    roleName: 'اسم الدور',
    newJob: 'وظيفة جديدة',
    sameJobAsExistingInATS: 'الوظيفة نفسها موجودة في ATS',
    addDescription: 'إضافة وصف',
    chooseExistingJob: 'اختيار وظيفة موجودة',
    budgetType: 'نوع الميزانية',
    openingType: 'نوع الوظيفة الشاغرة',
    employeeBackFillFor: 'الموظف (تعويض للوظيفة)',
    department: 'القسم',
    location: 'الموقع',
    employmentType: 'نوع التوظيف',
    targetHiredDate: 'تاريخ التوظيف المستهدف',
    targetSalaryPerCandidate: 'الراتب المستهدف لكل مرشح',
    hiringManager: 'مدير التوظيف',
    internalNotes: 'ملاحظات داخلية',
    budgeted: 'المدرجة في الميزانية',
    unbudgeted: 'غير مدرجة في الميزانية',
    newHire: 'توظيف جديد',
    backFillOrReplacement: 'تعويض/استبدال',
    monthly: 'شهري',
    quartly: 'ربع سنوي',
    halfYearly: 'نصف سنوي',
    yearly: 'سنوي',
    headcount: 'عدد الموظفين',
    placeHolders: {
      enterRoleName: 'أدخل اسم الدور',
      selectEmployee: 'اختر الموظف',
      selectDepartment: 'اختر القسم',
      selectLocation: 'اختر الموقع',
      selectEmploymentType: 'اختر نوع التوظيف',
      selectExpectedStartDate: 'اختر تاريخ البدء المتوقع',
      enterSalary: 'أدخل الراتب',
      selectHiringManager: 'اختر مدير التوظيف',
      addAdditionalInfo: 'أضف أي معلومات إضافية'
    },
    formRules: {
      openingId: 'رقم الوظيفة الشاغرة مطلوب',
      jobOpeningFor: 'يرجى اختيار الوظيفة الشاغرة لـ',
      roleName: 'يرجى إدخال اسم الدور',
      description: 'يرجى إدخال الوصف',
      budgetType: 'يرجى اختيار نوع الميزانية',
      openingType: 'يرجى اختيار نوع الوظيفة الشاغرة',
      employee: 'يرجى اختيار الموظف',
      department: 'يرجى اختيار القسم',
      location: 'يرجى اختيار الموقع',
      employmentType: 'يرجى اختيار نوع التوظيف',
      targetHiredDate: 'يرجى اختيار التاريخ المستهدف',
      salaryRange: 'يرجى إدخال نطاق الراتب',
      salaryCurrency: 'يرجى اختيار عملة الراتب',
      salaryFrequency: 'يرجى اختيار تكرار الراتب',
      hiringManager: 'يرجى اختيار مدير التوظيف',
      recruiter: 'يرجى اختيار مسؤول التوظيف',
      job: 'يرجى اختيار الوظيفة',
      offer: 'يرجى اختيار العرض',
      headcount: 'الرجاء إدخال عدد الموظفين.'
    }
  },
  filters: {
    job: 'الوظيفة | الوظيفة ({count})',
    department: 'القسم | القسم ({count})',
    location: 'الموقع | الموقع ({count})',
    targetHiredDate: 'تاريخ التوظيف المستهدف | تاريخ التوظيف المستهدف ({count})',
    recruiter: 'مسؤول التوظيف | مسؤول التوظيف ({count})',
    openingType: 'نوع الوظيفة الشاغرة | نوع الوظيفة الشاغرة ({count})',
    budgetType: 'نوع الميزانية | نوع الميزانية ({count})'
  },
  successMessages: {
    openingSavedAsDraft: 'تم حفظ الوظيفة الشاغرة بنجاح كمسودة',
    openingCreated: 'تم إنشاء الوظيفة الشاغرة بنجاح'
  }
}
